import {
    AutocompleteInput,
    BulkDeleteButton,
    Datagrid,
    DateField, DateInput, FunctionField,
    ListProps,
    NumberField, ReferenceInput, SelectInput,
    TextField
} from "react-admin";
import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {CustomList} from "../../components/CustomList";
import {getDefaultListProps, initField} from "../../shared/utils";
import {SubjectField} from "../../components/SubjectField";
import {CreateDeliveryToBlock} from "./CreateDeliveryToBlock";
import {ReferenceInputSubject} from "../../components/reference-inputs/ReferenceInputSubject";
import {Chip} from "@material-ui/core";


const BulkActions = () => {
    return <>
        <CreateDeliveryToBlock/>
        <BulkDeleteButton undoable/>
    </>
}


export const DeliveryAdministrativeBlockList = (props: ListProps) => {
    const {data: options} = useOptionsResource("GET");

    const filters = options ? [
        <DateInput alwaysOn {...initField("document_date_exact", options)}
                   label="Data doc."/>,
        <ReferenceInputSubject alwaysOn
                               {...initField("client", options)}
                               filter={{type: "client"}}
                               className="filter-field-small"
        />,
        <ReferenceInputSubject
            {...initField("carrier", options)}
            filter={{type: "carrier"}}
            label="Vettore"
            alwaysOn
        />,
        <ReferenceInputSubject
            {...initField("starting_point_on_delivery", options)}
            className="filter-field-small"
            label="Punto di partenza"
        />,
        <SelectInput {...initField("status", options, "array")} choices={options.status.choices} label="Stato"/>,
    ] : []

    return options ? (
        <CustomList
            sort={{field: "id", order: "DESC"}}
            {...getDefaultListProps(props)}
            filters={filters}
            bulkActionButtons={<BulkActions/>}
        >
            <Datagrid>
                <TextField {...initField("document_number", options)} />
                <DateField {...initField("document_date", options)} label={"Data doc."}/>
                <FunctionField label="Stato" source="status" render={(tableRecord: any) => {
                    let status = tableRecord.status;
                    if (status === "R") {
                        return (
                            <Chip
                                label="Rifutato"
                                color="primary"
                                variant="outlined"
                            />
                        );
                    } else if (status === "A") {
                        return tableRecord.delivery ? (
                            <Chip
                                label="Delivery →"
                                component="a"
                                target="_blank"
                                href={`/deliveries/${tableRecord.delivery}`}
                                clickable
                                style={{
                                    borderColor: "green",
                                    color: "green",
                                }}
                                variant="outlined"
                            />
                        ) : (
                            <Chip
                                label="Approvata"
                                style={{
                                    borderColor: "green",
                                    color: "white",
                                    backgroundColor: "green",
                                }}
                                variant="outlined"
                            />
                        );
                    } else {
                        return (
                            <Chip
                                label="In attesa"
                                style={{
                                    borderColor: "#ffa726",
                                    color: "#ef6c00",
                                    backgroundColor: "#fff3e0",
                                }}
                                variant="outlined"
                            />
                        );
                    }
                }}
                />
                <SubjectField {...initField("client_object", options)}
                              sortBy="client__business_name"/>
                <SubjectField {...initField("receiver_object", options)}
                              sortBy="receiver__business_name"/>
                <SubjectField {...initField("cessionary_object", options)}
                              sortBy="cessionary__business_name"/>
                <NumberField {...initField("weight", options)} />
                <NumberField {...initField("packages_number", options)} />
                <NumberField {...initField("volume", options)} />
                <NumberField {...initField("cachet", options)} label="Contrass." sortable={false}/>
            </Datagrid>
        </CustomList>) : null
}